import NfcCardBalancePanel from './NfcCardBalancePanel';

export default NfcCardBalancePanel;
